import React, { useState, useEffect } from 'react'
import { getFormsAndApps, transfromRowForTable } from './Helpers/Helper.js'
import { FormsAndAppFilter } from './FormsAndAppFilter.jsx'
import { FormsAndAppTable } from './FormsAndAppTable.jsx'
import { Loader } from '../loader/loader.jsx'
import { isEmpty } from 'lodash'

export function FormsAndApplications() {
  const [documents, setDocuments] = useState([])
  const [productDocuments, setProductDocuments] = useState([])
  const [productTypes, setProductTypes] = useState([])
  const [activeProduct, setActiveProduct] = useState()
  const [filters, setFilters] = useState([])
  const [selectedFilter, setSelectedFilter] = useState([])
  const [inputValue, setInputValue] = useState([])

  useEffect(() => {
    getData()
  }, [])

  useEffect(() => {
    changeProduct()
  }, [activeProduct])

  const getData = async () => {
    const data = await getFormsAndApps()
    const productTypesData = [
      ...new Set(data.map((document) => document.productType)),
    ]
    setDocuments(data)
    setProductTypes(productTypesData)

    let validProduct = ''
    if (window.location.search) {
      const urlParams = new URLSearchParams(window.location.search)
      const searchText = urlParams.get('search') || ''
      const productUrlParam =
        urlParams.get('category') && urlParams.get('category').toLowerCase()
      let filterUrlParam = urlParams.getAll('document')

      if (productUrlParam) {
        validProduct = productTypesData
          .filter(
            (product) =>
              product.replace(/.*\./, '') ===
              (productUrlParam === 'closed-end'
                ? productUrlParam
                : productUrlParam.replaceAll(' ', '-'))
          )
          .toString()
      }

      if (filterUrlParam) {
        filterUrlParam = filterUrlParam.map((filter) =>
          filter.toLowerCase().replaceAll(' ', '-')
        )
        setSelectedFilter(filterUrlParam)
      }
      setInputValue(searchText)
    }
    validProduct.length
      ? setActiveProduct(validProduct)
      : setActiveProduct(productTypesData[0])
  }

  const changeProduct = async () => {
    if (activeProduct) {
      const data = documents.filter((doc) => doc.productType === activeProduct)
      const filters = [...new Set(data.map((doc) => doc.documentType))]
      setFilters(filters)
      setProductDocuments(data)
    }
  }

  const validFilters = selectedFilter.filter((filter) =>
    filters.includes(filter)
  )
  const filteredDocuments = transfromRowForTable(
    productDocuments,
    validFilters,
    inputValue,
    'forms'
  )

  return (
    <div className="investment-products">
      <div className="u-paddingTop3gu u-borderColorNeutralLight u-borderTop0 u-borderBottom u-borderLeft0 u-borderRight0 u-bgColorWhite">
        <div className="u-sizeConstrained u-flex">
          <ul className="List List--inline List--selectable u-flexJustifyStart">
            {productTypes.map((item) => (
              // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions -- CTINEXT-4719
              <li
                key={item}
                className={
                  'u-textCapitalize u-textSizeMsrp1 u-paddingHoriz4gu u-sm-paddingHoriz1gu u-textBold List-item u-sm-textSizeMsr u-sm-flex u-textCenter u-flexAlignItemsCenter u-sm-flexGrow1 u-lg-flexAlignItemsTop' +
                  (item === activeProduct ? ' is-selected' : '')
                }
                onClick={() => {
                  setActiveProduct(item)
                  setInputValue('')
                  setSelectedFilter([])
                }}
                data-qa-automation={`${item} product tab`}
              >
                {item.includes('closed-end')
                  ? item.replace(/.*\./, '')
                  : item.replaceAll('-', ' ').replace(/.*\./, '')}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="u-sizeConstrained u-paddingBottom15gu">
        <FormsAndAppFilter
          {...{
            filters,
            inputValue,
            setInputValue,
            selectedFilter,
            setSelectedFilter,
          }}
        />
        {isEmpty(documents) ? (
          <Loader showBackground={false} />
        ) : (
          <FormsAndAppTable documents={filteredDocuments} />
        )}
      </div>
    </div>
  )
}
